import { render, staticRenderFns } from "./bonus.vue?vue&type=template&id=88d89b46&scoped=true"
import script from "./bonus.vue?vue&type=script&lang=js"
export * from "./bonus.vue?vue&type=script&lang=js"
import style0 from "./bonus.vue?vue&type=style&index=0&id=88d89b46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d89b46",
  null
  
)

export default component.exports